import { getLocalizedString } from '@grandvisionhq/utils';

const getProductTitle = (orderLineItem, intl)=>{
    var ref;
    if (((ref = orderLineItem.product.currentProduct) === null || ref === void 0 ? void 0 : ref.type) === 'SUNGLASSES') {
        return orderLineItem.product.brand || getLocalizedString(orderLineItem.product.name, intl.locale);
    }
    return getLocalizedString(orderLineItem.product.name, intl.locale);
};

export { getProductTitle };
//# sourceMappingURL=get-product-title.js.map
